export default {
    DOCUMENT_READY_NOTIFICATION_SNACKBAR: true
}